import { Box } from "components/Box/Box";

import * as S from "./styles";

function DashboardSummary({ data, canAccessHotelList }) {
  const cfaDisabledHotelIds = [
    "6449e7e5abd582feb900edbd", // dmel
    "62fef2d3058c188c80ea0066", // dgc
    "6434be5690f99a6e3787ec96", // dmk
    "639ff0c5e7b1e3b2b42d2eed", // daoSg
  ];

  const hotelIds = canAccessHotelList?.map((h) => h.hotelId) || [];
  const noNeedCfaHotels = hotelIds.some(id => cfaDisabledHotelIds.includes(id));

  return (
    <Box>
      <S.DashboardSummary>
        {data
          .filter((item) => {
            if (noNeedCfaHotels) {
              return (
                item.label !== "Call For Assistance" &&
                !item.label.includes("Total")
              );
            }
            return true;
          })
          .map(({ label, content, unit = "" }) => (
            <S.Item key={label}>
              <S.Label>{label}</S.Label>
              <S.Content>
                <span>{content}</span>
                <span className="unit">{unit}</span>
              </S.Content>
            </S.Item>
          ))}
      </S.DashboardSummary>
    </Box>
  );
}

export default DashboardSummary;
